import { ogImage, OG_SIZE } from "@/lib/og";
import { site } from "@/content/site";

// Root-level Open Graph image (§SMO). Applies to every route that does not
// define its own opengraph-image. Statically generated at build time.
export const alt = `${site.name} — AI agents for voice, WhatsApp, chat and web`;
export const size = OG_SIZE;
export const contentType = "image/png";

// Homepage headline, rendered through the shared brand card.
export default function OpengraphImage() {
  return ogImage({ title: "AI agents that do the work." });
}
